import "./aboutUs.scss";
import Banner from "../../Common/Banner/Banner";
import data from "./aboutUs.json";
import iconPathURL from "../../Common/iconPath";

export default function AboutUs() {
  const aboutData = data.data;

  return (
    <div className="about-container">
      <Banner imgSrc={iconPathURL("aboutUs/about_us.png")} title="About Us" />
      <section className="text-container-section col-xs-12 col-sm-12 col-md-12 col-lg-10">
        <div className="img-content">
          <div className="second-content">
            <h2 className="about-title">{aboutData.title}</h2>
            <p className="para-content">{aboutData.p1}</p>
            <p className="para-content">{aboutData.p2}</p>
            <p className="para-content">{aboutData.p3}</p>
            <p className="para-content">{aboutData.p4}</p>
          </div>
        </div>
      </section>
      <img
        className="img-content footer-content"
        src={iconPathURL("aboutUs/footer.png")}
        alt="img"
      ></img>
    </div>
  );
}
